/**
 * Created by bartdecorte on 17/05/2017.
 */
import Page from '../Page';
import RowDrag from '../../utils/RowDrag';
import Util from '../../utils/Util';
import DirtyUnloadNotifier from '../../utils/DirtyUnloadNotifier';
import Request from '../../utils/Request';
import ColumnData from '../../columns/objects/ColumnData';

class TablesEdit extends Page {
  constructor() {
    super();
    this.columnsNextIndex = 0;
    this.filtersNextIndex = 0;
    this.sortsNextIndex = 0;
    this.actionsNextIndex = 0;
    this.webhooksNextIndex = 0;
    this.columnData = new ColumnData();

    this.bindListeners();
    new DirtyUnloadNotifier('.js-dirty-unload-notify');
    this.bindKeys(this.keyBindings());
    this.lSelectorTableChanged(document.getElementById('table-name'));
  }

  keyBindings() {
    const bindings = super.keyBindings();
    const scope = this;
    return {
      ...bindings,
      'mod+s': (ev) => scope.lModS(ev),
    };
  }

  bindListeners() {
    let $body = $('body');
    let $pageHeading = $('.js-page-header');

    $('#batch-type').on('change', (ev) => {
      return this.lBatchTypeChanged(ev);
    });
    $body.on('change', '.js-selector-table', (ev) => {
      return this.lSelectorTableChanged(ev.target);
    });
    $('#selector-column').on('change', (ev) => {
      return this.lSelectorColumnChanged(ev);
    });
    $('#selector-filter').on('change', (ev) => {
      return this.lSelectorFilterChanged(ev);
    });
    $('#selector-sort').on('change', (ev) => {
      return this.lSelectorSortChanged(ev);
    });
    $('#selector-action').on('click', (ev) => {
      return this.lAddActionClicked(ev);
    })
    $('#selector-webhook').on('click', (ev) => {
      return this.lAddWebhookClicked(ev);
    })
    $body.on('change', '.js-column-type-id', (ev) => {
      return this.lColumnTypeChanged(ev);
    });
    $body.on('click', '#container-columns .js-btn-delete', (ev) => {
      return this.lRowDeleteButtonClicked(ev, 'column');
    });
    $body.on('click', '#container-filters .js-btn-delete', (ev) => {
      return this.lRowDeleteButtonClicked(ev, 'filter');
    });
    $body.on('click', '#container-sorts .js-btn-delete', (ev) => {
      return this.lRowDeleteButtonClicked(ev, 'sort');
    });
    $body.on('click', '#container-actions .js-btn-delete', (ev) => {
      return this.lRowDeleteButtonClicked(ev, 'action');
    });
    $body.on('click', '#container-webhooks .js-btn-delete', (ev) => {
      return this.lRowDeleteButtonClicked(ev, 'webhook');
    });
    $body.on(
      'mousedown',
      '#container-columns input, #container-columns select',
      (ev) => {
        $(window).one('mouseup', (ev2) => {
          $(ev.target)
            .parents('[draggable="false"]')
            .attr('draggable', 'true')
            .prop('draggable', true);
        });
        $(ev.target)
          .parents('[draggable="true"]')
          .attr('draggable', 'false')
          .prop('draggable', false);
        ev.stopPropagation();
        return true;
      }
    );
    $body.on('dragstart', '#container-columns tr', (ev) => {
      return this.lRowDragStart(ev, 'column');
    });
    $body.on(
      'mousedown',
      '#container-sorts input, #container-sorts select',
      (ev) => {
        $(window).one('mouseup', (ev2) => {
          $(ev.target)
            .parents('[draggable="false"]')
            .attr('draggable', 'true')
            .prop('draggable', true);
        });
        $(ev.target)
          .parents('[draggable="true"]')
          .attr('draggable', 'false')
          .prop('draggable', false);
        ev.stopPropagation();
        return true;
      }
    );
    $body.on('dragstart', '#container-sorts tr', (ev) => {
      return this.lRowDragStart(ev, 'sort');
    });
    $body.on('dragstart', '#container-actions tr', (ev) => {
      return this.lRowDragStart(ev, 'action');
    });
    $body.on('click', '.js-btn-delete-all', (ev) => {
      return this.lDeleteAllClick(ev);
    });
    $body.on('click', '.js-btn-reorder', (ev) => {
      return this.lReorderClick(ev);
    });
    $body.on('click', '.js-btn-generate', (ev) => {
      return this.lGenerateClick(ev);
    });
    $pageHeading.find('.js-btn-save').on('click', (ev) => {
      return this.lHeadingBtnSaveClick(ev);
    });
    $body.on('input change', '#name', (ev) => this.lLabelChanged(ev));
    $body.on('change', '.js-view-enabled', (ev) =>
      this.lViewEnabledChanged(ev)
    );
    $body.on('click', '.js-action-class-select-item', (ev) => this.lActionClassSelectItemClicked(ev));
  }

  lModS(ev) {
    ev.preventDefault();
    this.submitForm();
    return false;
  }

  lBatchTypeChanged(ev) {
    let $elt = $(ev.target);
    let val = $elt.val();
    $('[data-batch-type]').css('display', 'none');
    $('[data-batch-type="' + val + '"]').css('display', 'block');
  }

  lSelectorTableChanged(el) {
    let tableName = el.value;
    let identifier = el.dataset.table;
    this.guessTableName();
    this.updateActiveTable(tableName, identifier);
  }

  lSelectorColumnChanged(ev) {
    const $elt = $(ev.target);
    const databaseName = $elt.val();
    const column = this.columnData.getByDatabaseName(databaseName);
    this.appendColumn(column);
    $elt.val(0);
  }

  lSelectorFilterChanged(ev) {
    let $elt = $(ev.target);
    let columnName = $elt.val();
    this.appendFilter(columnName);
    $elt.val(0);
  }

  lSelectorSortChanged(ev) {
    let $elt = $(ev.target);
    let columnName = $elt.val();
    this.appendSort(columnName);
    $elt.val(0);
  }

  lAddActionClicked(ev) {
    let $elt = $(ev.target);
    this.appendAction();
    $elt.val(0);
  };

  lAddWebhookClicked(ev) {
    let $elt = $(ev.target);
    this.appendWebhook();
    $elt.val(0);
  };

  lColumnTypeChanged(ev) {
    let $elt = $(ev.target);
    this.updateColumnType($elt.parents('tr').first());
  }

  lRowDeleteButtonClicked(ev, type) {
    ev.preventDefault();
    let $elt =
      $(ev.target).get(0).tagName === 'TR'
        ? $(ev.target)
        : $(ev.target)
            .parents('tr')
            .first();
    this.deleteRows(type, $elt);
    return false;
  }

  lRowDragStart(ev, type) {
    let scope = this;

    let $elt =
      $(ev.target).get(0).tagName === 'TR'
        ? $(ev.target)
        : $(ev.target)
            .parents('tr')
            .first();

    new RowDrag({
      $row: $elt,
      ev: ev,
      type: type,
      callback: () => {
        scope.resetNumericSort(type);
      },
    });
  }

  lDeleteAllClick(ev) {
    ev.preventDefault();
    let $btn = $(ev.target).hasClass('js-btn-delete-all')
      ? $(ev.target)
      : $(ev.target)
          .parents('.js-btn-delete-all')
          .first();
    let type = $btn.data('type');
    this.deleteRowsForType(type);
    return false;
  }

  lReorderClick(ev) {
    ev.preventDefault();
    const $elt = $(ev.target).is('.js-btn-reorder')
      ? $(ev.target)
      : $(ev.target)
          .parents('.js-btn-reorder')
          .first();
    this.reorder($elt.data('type'));
    return false;
  }

  lGenerateClick(ev) {
    ev.preventDefault();
    const columnData = this.getAvailableColumnData();

    for (let i = 0; i < columnData.length; i++) {
      this.appendColumn(columnData[i]);
    }
    return false;
  }

  lHeadingBtnSaveClick(ev) {
    ev.preventDefault();
    this.submitForm();
    return false;
  }

  lActionClassSelectItemClicked(ev) {
    ev.preventDefault();
    const el = ev.target;
    const container = el.closest('.js-action-class-container');
    const labelText = el.innerText;
    const input = container.querySelector('.js-action-class');
    input.value = labelText;
    const label = container.querySelector('.js-action-label');
    const classList = label.classList;
    const remove = [];
    for (let i = 0; i < classList.length; i++) {
      let classListItem = classList.item(i);
      if (classListItem.startsWith('btn-')) {
        remove.push(classListItem);
      }
    }
    if (remove.length) {
      classList.remove(...remove);
    }
    classList.add(`btn-${labelText}`);
  }

  submitForm() {
    $('.js-table-actions .js-btn-save')
      .get(0)
      .click();
    return this;
  }

  async updateActiveTable(tableName, identifier) {
    const response = await this.fetchColumns(tableName);
    const columnData = new ColumnData(...response.data.columns);

    if (identifier == 1) {
      // Cache columns for module table
      this.columnData = columnData;
    }

    this.populateColumnSelectors(columnData, identifier);

    this.fetchModules(tableName, (data) => {
      let optionMarkup = '';

      for (let key in data.modules) {
        if (data.modules.hasOwnProperty(key)) {
          optionMarkup +=
            '<option value="' +
            data.modules[key].id +
            '">' +
            data.modules[key].name +
            '</option>';
        }
      }

      let $dependingSelects = $(
        '[data-modules-for-table="' + identifier + '"]'
      );
      let $dependingSelect, selectOptions;
      for (let i = 0; i < $dependingSelects.length; i++) {
        $dependingSelect = $($dependingSelects[i]);
        selectOptions = optionMarkup;
        if (typeof $dependingSelect.data('placeholder') !== typeof undefined) {
          selectOptions =
            '<option value="0">' +
            $dependingSelect.data('placeholder') +
            '</option>' +
            selectOptions;
        }
      }

      if (typeof $dependingSelect !== typeof undefined) {
        $dependingSelect.html(selectOptions);
      }
    });
  }

  populateColumnSelectorEl(columnData, $el) {
    let optionMarkup = '';
    let dangerPrefix = '(!) ';

    for (let i = 0; i < columnData.length; i++) {
      optionMarkup += '<option value="' + columnData[i].column_name + '" data-guessed-type="' + columnData[i].type_id + '" data-sort="' + columnData[i].sort + '">' + columnData[i].column_name + '</option>';
    }

    let activeValue = $el.find('option:selected').attr('value');
    let activeLabel = $el.find('option:selected').first().text();

    if (activeLabel.substr(0, 4) === dangerPrefix) {
      activeLabel = activeLabel.substr(4);
    }

    let activeExists = columnData.filter(c => c.column_name == activeValue).length;

    let selectOptions = optionMarkup;
    if (!activeExists && typeof activeValue !== typeof undefined && activeValue != 0) {
      selectOptions += '<option value="' + activeValue + '">' + dangerPrefix + activeLabel + '</option>';
    }

    if (typeof $el.data('placeholder') !== typeof undefined) {
      selectOptions = '<option selected value="0">' + $el.data('placeholder') + '</option>'
      + selectOptions;
    }

    $el.find('option').not('[data-is-special-value]').detach();
    $el.prepend(selectOptions);

    let $previouslyActiveOption = $el.find('option[value="' + activeValue + '"]');
    if ($previouslyActiveOption.length) {
      $previouslyActiveOption.prop('selected', true);
    } else {
      $el.find('option').first().prop('selected', true);
    }
  }

  populateColumnSelectors(columnData, identifier) {
    let $dependingSelects = $(`[data-for-table="${identifier}"]`);

    let $tableSelectedColumnType = document.querySelectorAll('select.js-column-type-id');
    for (let i = 0; i < $tableSelectedColumnType.length; i++) {
      const selectedOption = $tableSelectedColumnType[i].options[$tableSelectedColumnType[i].selectedIndex];
      if (selectedOption.value == 15) {
        const id = $tableSelectedColumnType[i].closest('[data-column-id]').getAttribute('data-column-id');
        this.addRichTextPresetListeners('existing', id);
      }
    }

    for (let i = 0; i < $dependingSelects.length; i++) {
      this.populateColumnSelectorEl(columnData, $($dependingSelects[i]));
    }
  }

  async populateColumnSelectorsForIdentifier(identifier) {
    const $dependentSelectors = $(`[data-for-table="${identifier}"]`);

    if ($dependentSelectors.length === 0) {
      return;
    }

    const $parentSelector = $(`[data-table="${identifier}"]`);

    if ($parentSelector.is('[data-for-table]')) {
      // The parent selector itself is dependent on another parent, populate it first
      const parentIdentifier = $parentSelector.data('for-table');
      await this.populateColumnSelectorsForIdentifier(parentIdentifier);
    }

    // Now actually populate what we initially intended
    const tableName = $parentSelector.val();

    if (tableName == 0) {
      // No table selected, abort
      return;
    }

    const response = await this.fetchColumns(tableName);
    const columnData = new ColumnData(...response.data.columns);
    this.populateColumnSelectors(columnData, identifier);
  }

  lLabelChanged(ev) {
    const $input = $('#name');
    let touched = true;

    if (this.guessedTableName() === $input.val()) {
      touched = false;
    }

    return this.labelTouched(touched);
  }

  lViewEnabledChanged(ev) {
    const $elt = $(ev.target);
    const viewName = $elt.data('view-name');
    const isActive = $elt.is(':checked');
    this.setViewDefaultActive(viewName, isActive);
    if (this.getDefaultView().is(':disabled')) {
      this.setFirstEnabledViewAsDefault();
    }
  }

  labelTouched(labelTouched) {
    const $input = $('#name');

    if (typeof labelTouched === typeof undefined) {
      return $input.data('touched');
    }

    $input.attr('data-touched', labelTouched).data('touched', labelTouched);
    return this;
  }

  getAvailableColumnData() {
    return this.columnData.sort((a, b) => {
      if (a.sort < b.sort) {
        return -1;
      }

      if (b.sort > a.sort) {
        return 1;
      }

      return 0;
    });
  }

  dbNameToTableName(dbName) {
    return Util.capitalize(dbName.replace(/_/g, ' '));
  }

  guessedTableName() {
    const dbName = $('#table-name').val();
    return this.dbNameToTableName(dbName);
  }

  appendRow(type, columnName, inputs, values) {
    let typePlural = type + 's';

    let $proto = $('#' + type + '-row-proto');
    let $row = $proto.clone();
    $row.css('display', 'table-row');

    for (let i = 0; i < inputs.length; i++) {
      let kebabCased = inputs[i].replace('_', '-');
      let $inputs = $row.find(`.js-${type}-${kebabCased}`);

      for (let j = 0; j < $inputs.length; j++) {
        let $input = $($inputs[j]);
        let input = $input.get(0);
        let oldId = $input.attr('id');
        let newId =
          'new-' +
          type +
          '-' +
          this[typePlural + 'NextIndex'] +
          '-' +
          kebabCased;

        $input
          .attr(
            'name',
            'new_' +
              typePlural +
              '[' +
              this[typePlural + 'NextIndex'] +
              '][' +
              inputs[i] +
              ']'
          )
          .removeAttr('disabled');

        if (oldId) {
          $input.attr('id', newId);
          const labels = $row.get(0).querySelectorAll(`[for="${oldId}"]`);
          labels.forEach((label) => {
            label.setAttribute('for', newId);
          });
        }

        if (values.hasOwnProperty(inputs[i]) && $input.attr('type') !== 'hidden') {
          let value = values[inputs[i]];
          if ($input.attr('type') === 'checkbox') {
            $input.prop('checked', value);
          } else {
            $input.val(value);
          }
        }
      }
    }
    $row.data(type + '-index', this[typePlural + 'NextIndex']);
    $row.removeAttr('id');
    $('#container-' + typePlural).append($row);

    this.resetNumericSort(type);
    this[typePlural + 'NextIndex']++;
    return $row;
  }

  deleteRows(type, $elts) {
    for (let i = 0; i < $elts.length; i++) {
      $($elts[i])
        .addClass(`js-${type}-deleted`)
        .css('display', 'none')
        .find(`.js-${type}-delete`)
        .val(1);
    }

    this.resetNumericSort(type);
    return this;
  }

  deleteRowsForType(type) {
    let typePlural = type + 's';
    let $rows = $('#container-' + typePlural).find('tr');
    this.deleteRows(type, $rows);
    return this;
  }

  appendColumn(columnData) {
    const values = { ...columnData };
    values.delete = 0;
    values.visible = values.visibility;
    values.editable = values.editability;

    let $row = this.appendRow(
      'column',
      values.column_name,
      ['visible', 'editable', 'url_param', 'column_name', 'type_id', 'name', 'group', 'info', 'condition', 'width', 'delete', 'sort'],
      values
    );

    $row.find('.js-column-type-id').trigger('change');
  }

  appendFilter(columnName) {
    return this.appendRow(
      'filter',
      columnName,
      ['column_name', 'operator', 'value', 'single', 'delete'],
      { column_name: columnName }
    );
  }

  appendSort(columnName) {
    return this.appendRow(
      'sort',
      columnName,
      ['column_name', 'direction', 'delete', 'sort'],
      { column_name: columnName }
    );
  }

  appendAction(columnName) {
    return this.appendRow(
        'action',
        columnName,
        ['label', 'url', 'class', 'type', 'delete', 'sort'],
        {column_name: columnName}
    );
  };

  appendWebhook(columnName) {
    return this.appendRow(
      'webhook',
      columnName,
      ['url', 'delete'],
      {column_name: columnName}
    );
  };

  defaultSettingsForColumn(columnName) {
    for (let i = 0; i < this.columnData.length; i++) {
      if (this.columnData[i].column_name === columnName) {
        return this.columnData[i];
      }
    }
  }

  async updateColumnType($columnRow) {
    let columnRow = $columnRow.get(0);
    let preExisting = typeof $columnRow.data('column-id') !== typeof undefined;
    let identifier = preExisting
      ? $columnRow.data('column-id')
      : $columnRow.data('column-index');
    let prefix = preExisting ? 'existing' : 'new';

    let typeId = $columnRow.find('.js-column-type-id').val();

    let columnName = $columnRow.find('.js-column-column-name').val();
    let oldSettings = this.getSettings($columnRow.find('.js-column-settings').first());
    let $newSettings = $(esign.info.columnSettingsMarkup[typeId]);
    let newSettings = this.getSettings($newSettings);
    let newSettingKeys = Object.keys(newSettings);
    let defaultSettings = preExisting ? [] : this.defaultSettingsForColumn(columnName).settings;

    let $tableSelectors = $newSettings.find('[data-table]');
    let selectorRegex = /^[0-9]+$/;

    // Set options of settings that require database table, database column, or other module selection
    for (let i = 0; i < $tableSelectors.length; i++) {
      let $tableSelector = $($tableSelectors[i]);
      let $columnSelectors = $newSettings.find(
        '[data-for-table="' + $tableSelector.data('table') + '"]'
      );
      let $moduleSelectors = $newSettings.find(
        '[data-modules-for-table="' + $tableSelector.data('table') + '"]'
      );
      let selectorIdentifier = prefix + '-column-' + identifier + '-' + i;

      $tableSelector
        .attr('data-table', selectorIdentifier)
        .data('table', selectorIdentifier);

      for (let j = 0; j < $columnSelectors.length; j++) {
        let $columnSelector = $($columnSelectors[j]);
        if (!$columnSelector.data('for-table').match(selectorRegex)) {
          $columnSelector
            .attr('data-for-table', selectorIdentifier)
            .data('for-table', selectorIdentifier);
        }
      }

      for (let j = 0; j < $moduleSelectors.length; j++) {
        let $moduleSelector = $($moduleSelectors[j]);
        if (!$moduleSelector.data('modules-for-table').match(selectorRegex)) {
          $moduleSelector
            .attr('data-modules-for-table', selectorIdentifier)
            .data('modules-for-table', selectorIdentifier)
          ;
        }
      }
    }

    let $actionsContainer = $columnRow.find('.actions-container').first();
    $actionsContainer.find('.js-column-settings').detach();
    $actionsContainer.append($newSettings);

    let $settings = $newSettings.find('[data-setting-name]');
    for (let i = 0; i < $settings.length; i++) {
      let $setting = $($settings[i]);

      // Selects depending on each other
      if ($setting.is('[data-for-table]')) {
        await this.populateColumnSelectorsForIdentifier($setting.data('for-table'));
      }

      let settingName = $setting.data('setting-name');

      // Old & guessed setting values
      // If old settings exist, copy over to the new settings markup. If no old settings exist, but default values do,
      // copy those over to the new settings markup.
      let settingKeyIndex = newSettingKeys.indexOf(settingName);
      if (settingKeyIndex > -1) {
        let settingKey = newSettingKeys[settingKeyIndex];
        let settingSelector = `[data-setting-name="${settingKey}"]:not([type="hidden"])`;
        if (oldSettings.hasOwnProperty(settingKey)) {
          Util.setValue($newSettings.find(settingSelector), oldSettings[settingKey]);
        } else if (defaultSettings.hasOwnProperty(settingKey)) {
          Util.setValue($newSettings.find(settingSelector), defaultSettings[settingKey]);
        }
      }

      let kebabCased = settingName.replace('_', '-');
      let id = prefix + '-column-' + identifier + '-setting-' + kebabCased;

      // Set template html input name
      $setting
        .attr('name', prefix + '_columns[' + identifier + '][settings][' + settingName + ']')
      ;

      // If there is a hidden input (holding a default, like for a boolean checkbox), update it's name as wel
      if ($setting.prev().length && $setting.prev().get(0).tagName === 'INPUT'
          && $setting.prev().attr('type') === 'hidden') {
        $setting.prev()
          .attr('name', `${prefix}_columns[${identifier}][settings][${settingName}]`);
      }

      // Make template html input id unique
      if ($setting.attr('id')) {
        $setting.attr('id', id);
      }

      // Link the label to the input should it exist
      let $label = $newSettings.find('[data-for-setting="' + settingName + '"]');
      if ($label.length) {
        $label.attr('for', id);
      }
    }

    // If old settings exist, copy over to the new settings markup. If no old settings exist, but default values do,
    // copy those over to the new settings markup.
    for (let i = 0; i < newSettingKeys.length; i++) {
      let key = newSettingKeys[i];
      let selector = `[data-setting-name="${key}"]:not([type="hidden"])`;
      if (oldSettings.hasOwnProperty(key)) {
        Util.setValue($newSettings.find(selector), oldSettings[key]);
      } else if (defaultSettings.hasOwnProperty(key)) {
        Util.setValue($newSettings.find(selector), defaultSettings[key]);
      }
    }

    let modalIdentifier = `${preExisting ? '' : 'new-'}column-settings-${identifier}`;
    $newSettings.attr('id', modalIdentifier);
    $actionsContainer
      .find('.js-btn-settings')
      .css('display', $newSettings.length ? 'inline-block' : 'none')
      .attr('href', '#' + modalIdentifier);

    let selectedTypeOption = columnRow.querySelector(`.js-column-type-id option[value="${typeId}"]`);

    let columnAttributes = selectedTypeOption.dataset;
    const hideableAttributes = {
      'visible': 'visible',
      'editable': 'edit',
      'column-name': 'columnName',
    };

    for (let i = 0; i < Object.keys(hideableAttributes).length; i++) {
      const attribute = Object.keys(hideableAttributes)[i];
      const attributeStudly = hideableAttributes[attribute]
      const attributeVisible = parseInt(columnAttributes[attributeStudly], 10);
      const els = columnRow.querySelectorAll(`.js-column-${attribute}`);
      [...els].forEach(el => {
        el.disabled = !attributeVisible;

        // A toggle has a wrapper element
        const hideEl = el.classList.contains('js-custom-switch') ? el.parentElement : el;
        if (attributeVisible) {
          hideEl.style.removeProperty('display');
        } else {
          hideEl.style.display = 'none';
        }
      });
    }

    if (typeId == 15) {
      this.addRichTextPresetListeners(prefix,  identifier);
    }
  }

  addRichTextPresetListeners(prefix, identifier) {
    const prefixIdentifier = prefix + '-column-' + identifier;
    const selectorToolbar = document.getElementById(prefixIdentifier + '-setting-toolbar');
    const selectorAllowedContent = document.getElementById(prefixIdentifier + '-setting-allowedcontent');
    const selectorFormatTags = document.getElementById(prefixIdentifier + '-setting-formattags');
    const richTextPresets = {
      simple: {
        allowedContent: 'p; strong; em; a[href,target]',
        formatTags: 'p',
      },
      standard: {
        allowedContent: 'p; h2; h3; ul; ol; li; strong; em; a[href,target]',
        formatTags: 'p; h2; h3;',
      }
    };

    selectorToolbar.addEventListener("change", function() {
      if (this.value) {
        selectorAllowedContent.value = richTextPresets[this.value].allowedContent
        selectorAllowedContent.value = richTextPresets[this.value].formatTags
      }
    });

    selectorAllowedContent.addEventListener("change", function() {
      selectorToolbar.value = '';
    });

    selectorFormatTags.addEventListener("change", function() {
      selectorToolbar.value = '';
    });
  }

  getSettings($rootElt) {
    if (!$rootElt.length) return {};
    let preExisting = typeof $rootElt.data('column-id') !== typeof undefined;

    let $oldSettings = $rootElt.find('[data-setting-name]');
    let oldSettings = {};
    for (let i = 0; i < $oldSettings.length; i++) {
      let $oldSetting = $($oldSettings[i]);
      oldSettings[$oldSetting.data('setting-name')] = Util.getValue(
        $oldSetting
      );
    }
    return oldSettings;
  }

  resetNumericSort(type) {
    let typePlural = type + 's';
    let $rows = $('#container-' + typePlural)
      .first()
      .find('tr')
      .not(`#${type}-row-proto`)
      .not(`.js-${type}-deleted`);

    for (let i = 0; i < $rows.length; i++) {
      let $row = $($rows[i]);
      $row
        .find('.js-' + type + '-sort')
        .first()
        .val(i);
    }
    return this;
  }

  fetchColumns(tableName) {
    const url = 'websites/' + esign.info.websiteId + '/db/tables/' + tableName + '/columns';
    return new Request(url, 'GET')
      .execute();
  };

  fetchModules(tableName, onSuccess, onError, onComplete) {
    const url =
      'websites/' +
      esign.info.websiteId +
      '/db/tables/' +
      tableName +
      '/modules';
    return new Request(url, 'GET')
      .execute()
      .then((response) => {
        if (response.errors.length) {
          if (typeof onError !== typeof undefined) onError(response.errors);
        } else {
          if (typeof onSuccess !== typeof undefined) onSuccess(response.data);
        }
      })
      .catch(() => {
        if (typeof onError !== typeof undefined) onError();
      })
      .then(() => {
        if (typeof onComplete !== typeof undefined) onComplete();
      });
  }

  guessTableName() {
    if (!this.labelTouched()) {
      $('#name').val(this.guessedTableName());
      this.labelTouched();
    }
    return this;
  }

  reorder(type) {
    const typePlural = type + 's';

    const data = this.getAvailableColumnData();
    const columnsKeyedByName = [];
    data.map(x => {
      columnsKeyedByName[x.column_name] = x.sort;
      return x;
    });

    const $container = $('#container-' + typePlural).first();
    const $rows = $container.find('tr').not('#' + type + '-row-proto');
    let sortData = [];
    for (let i = 0; i < $rows.length; i++) {
      let $row = $($rows[i]);
      let column = $row.find('.js-' + type + '-column-name').val();
      sortData.push({
        $row: $row,
        sort: columnsKeyedByName[column]
      });
    }

    sortData = sortData.sort((a, b) => {
      if (a.sort < b.sort) {
        return -1;
      }

      if (a.sort > b.sort) {
        return 1;
      }
      if (a.sort > b.sort) return 1;

      return 0;
    });

    for (let i = 0; i < sortData.length; i++) {
      sortData[i].$row.detach();
      $container.append(sortData[i].$row);
      sortData[i].$row.find('.js-' + type + '-sort').val(sortData[i].sort);
    }

    return this;
  }

  setViewDefaultActive(viewName, isActive) {
    const $elt = $('.js-view-default[value="' + viewName + '"]');
    $elt.prop('disabled', !isActive);

    if ($elt.is(':checked')) {
      this.setFirstEnabledViewAsDefault();
    }

    return this;
  }

  getDefaultView() {
    return $('.js-view-default:checked');
  }

  setViewDefaultChecked(viewName, isChecked) {
    const $elt = $('.js-view-default[value="' + viewName + '"]');
    $elt.prop('checked', isChecked);
    return this;
  }

  setFirstEnabledViewAsDefault() {
    const $enabledToggles = $('.js-view-enabled:checked');

    if ($enabledToggles.length) {
      const $enabledToggle = $($enabledToggles[0]);
      this.setViewDefaultChecked($enabledToggle.data('view-name'), true);
    }
  }
}

export default TablesEdit;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/Tables/TablesEdit.js